/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAlarmClock = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M19 1c2.21 0 4 1.815 4 4.054a4.065 4.065 0 0 1-1.714 3.327l.026.067a10.23 10.23 0 0 1 .688 3.7c0 2.692-1.035 5.139-2.724 6.954l2.431 2.465L20.293 23l-2.533-2.566a9.864 9.864 0 0 1-5.76 1.85 9.864 9.864 0 0 1-5.774-1.86L3.707 23l-1.414-1.433 2.42-2.477A10.173 10.173 0 0 1 2 12.148c0-1.306.244-2.554.688-3.7l.026-.068A4.062 4.062 0 0 1 1 5.054C1 2.815 2.79 1 5 1a3.98 3.98 0 0 1 3.283 1.737l-.053.021A9.856 9.856 0 0 1 12 2.013c1.324 0 2.588.261 3.745.735l-.027-.01A3.977 3.977 0 0 1 19 1zm-7 3.04c-4.418 0-8 3.63-8 8.108 0 4.478 3.582 8.108 8 8.108s8-3.63 8-8.108c0-4.477-3.582-8.108-8-8.108zm1 2.027v5.067h3v2.028h-5V6.067zm6-3.04c-.588 0-1.118.258-1.484.668l.181.123a10.129 10.129 0 0 1 2.655 2.755l-.01-.017c.404-.369.658-.905.658-1.502 0-1.12-.895-2.027-2-2.027zm-14 0c-1.105 0-2 .907-2 2.027 0 .596.254 1.132.658 1.503a10.132 10.132 0 0 1 2.645-2.74l.18-.123A1.98 1.98 0 0 0 5 3.027z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAlarmClock as AlarmClock };
